import { render, staticRenderFns } from "./share-modal-actions.vue?vue&type=template&id=98be5f8a&scoped=true&"
import script from "./share-modal-actions.vue?vue&type=script&lang=ts&"
export * from "./share-modal-actions.vue?vue&type=script&lang=ts&"
import style0 from "./share-modal-actions.vue?vue&type=style&index=0&id=98be5f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98be5f8a",
  null
  
)

export default component.exports